import { PhpFloat, PhpArray } from '../php-compat/ordered-array';

/** json_decode(..., true) number/key types, for hashing original authored JSON.
 * The regular compiler still serves plain JSON; integral doubles stay typed here. */
export function decodePhpJson(source: string): unknown {
    let at = 0;
    const space = (): void => { while (/[\x20\t\r\n]/.test(source[at] ?? '') && at < source.length) at++; };
    function parse(): unknown {
        space(); const start = at, char = source[at++];
        if (char === '"') {
            while (at < source.length) {
                const c = source[at++];
                if (c === '\\') at++;
                else if (c === '"') return JSON.parse(source.slice(start, at)) as string;
            }
            throw new SyntaxError('Unterminated JSON string');
        }
        if (char === '[' || char === '{') {
            const end = char === '[' ? ']' : '}', result = new PhpArray(); let index = 0;
            space(); if (source[at] === end) { at++; return result; }
            for (;;) {
                const key = char === '[' ? index++ : parse();
                if (char === '{') { space(); if (typeof key !== 'string' || source[at++] !== ':') throw new SyntaxError('Invalid JSON member'); }
                result.set(key as string | number, parse());
                space(); const separator = source[at++];
                if (separator === end) return result;
                if (separator !== ',') throw new SyntaxError('Invalid JSON separator');
            }
        }
        at = start;
        for (const [word, value] of [['true', true], ['false', false], ['null', null]] as const)
            if (source.startsWith(word, at)) { at += word.length; return value; }
        const token = /^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?/.exec(source.slice(at))?.[0];
        if (!token) throw new SyntaxError('Invalid JSON value');
        at += token.length;
        if (/[.eE]/.test(token)) return new PhpFloat(Number(token));
        const integer = BigInt(token);
        return integer < -9223372036854775808n || integer > 9223372036854775807n ? new PhpFloat(Number(token)) : integer;
    }
    const value = parse(); space();
    if (at !== source.length) throw new SyntaxError('Trailing JSON input');
    return value;
}
